import gql from 'graphql-tag';

const OCDocumentFragment = gql`
	fragment OCDocumentFragment on OfferingCircularsDocument {
		title
		anchor {
			current
		}
		document {
			asset {
				url
				extension
			}
		}
	}
`;

export const OfferingCircularsPageQuery = gql`
	query {
		allOfferingCirculars {
			tableOfContents: tableOfContentsRaw
			taxForms: taxFormsRaw
			disclaimer: disclaimerRaw
			registeredFunds {
				...OCDocumentFragment
			}
			regulationAOfferings {
				...OCDocumentFragment
			}
			regulationDOfferings {
				...OCDocumentFragment
			}
			otherOfferings {
				...OCDocumentFragment
			}
			advisorsDisclosureDocuments {
				...OCDocumentFragment
			}
		}
	}
	${OCDocumentFragment}
`;
